import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core'
import TopBar from './TopBar'
import Footer from './Footer'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
  },
  content: {
    flexGrow: 1,   
    display: 'flex',
    flexDirection: 'column',
  }
}))

function PSAHomePageLayout({ children }) {
  const classes = useStyles()

  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']")
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.getElementsByTagName('head')[0].appendChild(link)
    }
    link.href = process.env.PUBLIC_URL + '/static/psaAssets/favicon-psa.png'
  }, [])

  return (
    <div className={classes.root}>
      <TopBar />
      <div className={classes.content}>
        {children} 
      </div>
      <Footer />
    </div>
  )
}

export default PSAHomePageLayout
